import _ from 'lodash';

const state = {
  loadingComponents: [],
};

const getters = {
  appLoading: state => state.loadingComponents.length !== 0,
};

const actions = {
  startLoading({ commit }, componentName) {
    commit('addLoadingComponent', componentName);
  },
  doneLoading({ state, commit }, componentName) {
    commit('removeLoadingComponent', componentName);
  },
  clearLoader({ commit }) {
    commit('clearLoader');
  },
};

const mutations = {
  addLoadingComponent(state, componentName) {
    if (!_.includes(state.loadingComponents, componentName)) {
      state.loadingComponents.push(componentName);
    }
  },
  removeLoadingComponent(state, componentName) {
    const index = _.indexOf(state.loadingComponents, componentName);
    state.loadingComponents.splice(index, 1);
  },
  clearLoader(state) {
    state.loadingComponents.splice(0, state.loadingComponents.length);
  },
};


export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/loader.js